import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import DropdownSelect from '../../components/DropdownSelect';
import HotelController, { RoomTipType } from '../../controller/HotelController';
import { useToast } from '../../controller/ToastController';
import StoreController, { CurrentStoreContext, StoreType } from '../../controller/StoreController';

const paymentPriceList: any = [];
const tipPriceList: any = [];
for (let i = 0; i <= 10; i++) {
  const amount = i * 10000;
  paymentPriceList.push({
    key: i - 1,
    value: Number(amount),
    name: `${amount.toLocaleString()}원`,
    label: `${amount.toLocaleString()}원`,
  });
}
for (let i = 0; i <= 5; i++) {
  const amount = i * 1000;
  tipPriceList.push({
    key: i - 1,
    value: Number(amount),
    name: `${amount.toLocaleString()}원`,
    label: `${amount.toLocaleString()}원`,
  });
}
const HotelTip = () => {
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [tipPriceDefalut, setTipPriceDefalut] = useState<any>({
    key: -1,
    value: '0',
    name: `객실관리팁 표준금액`,
    label: `객실관리팁 표준금액`,
  });
  const [chargeDefalut, setChargeDefalut] = useState<any>([
    {
      key: -1,
      value: '0',
      name: `할증구간`,
      label: `할증구간`,
    },
    {
      key: -1,
      value: '0',
      name: `할증금액`,
      label: `할증금액`,
    },
  ]);
  const [inputBlocks, setInputBlocks] = useState<number[]>([]);
  const [chargeValues, setChargeValues] = useState<any[]>([]);
  const [paymentPrice, setPaymentPrice] = useState<any>('');
  const [tipPrice, setTipPrice] = useState<any>('');

  const onChangePaymentPrice = (e: any, index: number) => {
    if (index === -1) {
      setPaymentPrice(Number(e.target.value));
    } else {
      const updatedChargeValues = [...chargeValues];
      updatedChargeValues[index] = {
        ...updatedChargeValues[index],
        order_price: Number(e.target.value),
      };
      setChargeValues(updatedChargeValues);
    }
  };
  const onChangeTipPrice = (e: any, index: number) => {
    if (index === -1) {
      setTipPrice(e.value);
    } else {
      const updatedChargeValues = [...chargeValues];
      updatedChargeValues[index] = { ...updatedChargeValues[index], room_tip: e.value };
      setChargeValues(updatedChargeValues);
    }
  };

  // 할증구간 추가,삭제
  const handleAddBlock = () => {
    setInputBlocks((prevBlocks) => [...prevBlocks, prevBlocks.length]);
    setChargeValues((prevValues) => [...prevValues, { order_price: '', room_tip: '' }]);
  };
  const handleRemoveBlock = (blockIndex: number) => {
    setInputBlocks((prevBlocks) => prevBlocks.filter((_, index) => index !== blockIndex));
    setChargeValues((prevValues) => prevValues.filter((_, index) => index !== blockIndex));
  };

  const submitRoomTip = async () => {
    const totalRoomTips = [
      {
        order_price: paymentPrice,
        room_tip: tipPrice,
      },
      ...chargeValues,
    ];
    if (totalRoomTips.some((tip) => tip.order_price === '' || tip.room_tip === '')) {
      showToast('선택되지 않은 값이 있습니다.', 'error');
    } else {
      await setRoomtip(totalRoomTips);
    }
  };

  const setRoomtip = async (roomTipList: RoomTipType[]) => {
    try {
      const oParams = {
        store_id: currentStore.value,
        room_tip: roomTipList,
      };
      const oRes: any = await HotelController.setRoomtip(oParams);
      if (oRes && oRes.data) {
        showToast('저장되었습니다.');
        getRoomtip();
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const getRoomtip = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
      };
      const oRes: any = await HotelController.getRoomtip(oParams);

      if (oRes && oRes.data) {
        const fetchedRoomTips = oRes.data.data;
        if (fetchedRoomTips.length > 0) {
          setPaymentPrice(fetchedRoomTips[0].order_price);
          setTipPrice(fetchedRoomTips[0].room_tip);

          if (fetchedRoomTips.length > 1) {
            const additionalChargeValues = fetchedRoomTips.slice(1).map((tip: any) => ({
              order_price: tip.order_price,
              room_tip: tip.room_tip,
            }));

            setChargeValues(additionalChargeValues);
            setInputBlocks(additionalChargeValues.map((_: any, index: number) => index));
          }
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  React.useEffect(() => {
    getRoomtip();
  }, []);

  return (
    <Style>
      <div className="contentContainer">
        <div className="inputText">
          <div className="title">
            <h4>주문금액 구간별 객실관리 팁</h4>
          </div>
          <div className="inputWrap">
            <p>총 주문금액이</p>
            <input
              type="number"
              value={paymentPrice}
              onChange={(e: any) => onChangePaymentPrice(e, -1)}
              placeholder="최소부과기준금액"
            />
            <p>이상일 때</p>
            <DropdownSelect
              options={tipPriceList}
              defaultValue={
                tipPriceList.find((item: any) => item.value === tipPrice) || tipPriceDefalut
              }
              onChangeValue={(e: any) => onChangeTipPrice(e, -1)}
            />
            <p>부과됩니다.</p>
          </div>
          {inputBlocks.length > 0 &&
            inputBlocks.map((blockIndex) => (
              <div className="inputWrap" key={blockIndex}>
                <button className="removeButton" onClick={() => handleRemoveBlock(blockIndex)}>
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_minus.svg`} alt="삭제아이콘" />
                </button>
                <input
                  type="number"
                  value={chargeValues[blockIndex]?.order_price}
                  onChange={(e: any) => onChangePaymentPrice(e, blockIndex)}
                  placeholder="할증구간"
                />
                <p>초과되면</p>
                <DropdownSelect
                  options={tipPriceList}
                  defaultValue={
                    tipPriceList.find(
                      (item: any) => item.value === chargeValues[blockIndex]?.room_tip,
                    ) || chargeDefalut[1]
                  }
                  onChangeValue={(e: any) => onChangeTipPrice(e, blockIndex)}
                />
                <p>더 부과됩니다.</p>
              </div>
            ))}
          {inputBlocks.length < 2 && (
            <button className="plusTipButton" onClick={handleAddBlock}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="추가아이콘" />
              <p>할증 구간 추가하기</p>
            </button>
          )}
          <button className="submitButton" onClick={submitRoomTip}>
            저장
          </button>
        </div>
      </div>
    </Style>
  );
};

export default HotelTip;

const Style = styled.div`
  h4 {
    font-size: 18px;
    font-weight: 500;
    color: #555;
  }
  p {
    font-size: 14px;
    font-weight: 500;
    color: #555;
  }

  /* title */
  .title {
    margin-bottom: 55px;
  }
  /* inputText */
  .inputText {
    input {
      width: 100%;
      padding: 10px 22px;
      margin-top: 6px;
      border: 1px solid #cecece;
      border-radius: 5px;
    }
  }
  .inputWrap {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
  }
  .inputWrap p,
  .inputWrap button {
    flex: 1 1 10%;
    text-align: center;
  }
  .inputWrap > div {
    flex: 1 1 20%;
  }
  .selector,
  input {
    flex: 1;
    width: 100%;
    min-width: 170px;
  }
  input {
    border: none;
    border-bottom: 1px solid #cecece;
    font-size: 14px;
  }

  /* plusTipButton */
  .plusTipButton {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 37px;
    margin-top: 30px;
    padding: 10px;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    p {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      color: #4dd2ae;
    }
  }
  .removeButton {
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }

  /* submitButton */
  .submitButton {
    width: 100%;
    margin-top: 400px;
    text-align: center;
  }

  /* input설정 */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
  
  @media (max-width: 600px) {
    .inputWrap > div {
      width: auto;
      max-width: 100px;
    }
    .selector,
    input {
      min-width: auto;
      max-width: 100px;
    }
    .inputWrap input {
      min-width: 100px;
      margin-top: 0;
      padding: 8px;
    }
    .submitButton {
      margin-top: 30px;
    }
  }
  @media (max-width: 500px) {
    .inputWrap p {
      font-size: 10px;
    }
    .inputWrap > div {
      max-width: 80px;
    }
    .selector,
    input {
      max-width: 80px;
    }
    .inputWrap input {
      min-width: 80px;
    }
  }
`;
